import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from "moment";
import axios from "axios";
import { debounce } from "lodash";
import Slider from 'rc-slider';
import Select from 'react-select';
import { Trans } from 'react-i18next';

import DatePicker from '../../../Common/DatePicker';
import { setBookingsDb, setReturnReleaseBookings, setVehicleDb } from '../../../../Actions/dataActions';
import { setList, configureBookingDictionary, closePullout } from '../../../../Actions/stakeholderActions';
import { receiveTime, generateTimings } from '../../../../Helpers/ReceiveTimeInArray';

import { company_title } from '../../../../Helpers/ProfileHelper';
import { LoadingIcon } from '../../../Common/Loading_Icon';
import { ActionApproveUser, ReleaseVehicle, TimeDefault, UserDefault, VehicleDamaged, VehicleDefault } from '../../../Common/Buttons/Icons';

import { ReleaseCheckInVehicleButton } from './ReleaseCheckInVehicleButton';

class ReleaseCheckInOverlay extends Component {
    constructor(props) {
        super(props);

        this.updateForm = this.updateForm.bind(this);
        this.updateSelect = this.updateSelect.bind(this);
        this.updateDamage = this.updateDamage.bind(this);
        this.updateCheckbox = this.updateCheckbox.bind(this);
        this.updateSlider = this.updateSlider.bind(this);
        this.releaseVehicle = debounce(this.releaseVehicle.bind(this), 500);
        this.returnVehicle = debounce(this.returnVehicle.bind(this), 500);

        this.odometerRef = React.createRef();

        this.state = {
            calendarBooking: null,
            damage: "0",
            current_form: {},
            form_details: {},
            vehicle_id: null,
            current_time: "9:00 am",
            timings: [],
            confirms: {
                booking_confirm: false,
                vehicle_confirm: false,
                damage_confirm: false,
            },
            previous_odometer: 0,
            current_booking: null,
            error_class: {
                booking_confirm: false,
                vehicle_confirm: false,
                damage_confirm: false,
                odometer: false,
            }
        };
    }

    componentDidMount() {
        this.setState({ calendarBooking: this.props.stakeholder.current_booking });

        var self = this;
        if (window.innerWidth < 1500) {
            this.props.dispatch(closePullout())
        }

        if (this.props.release) {
            axios.get('/ajax/release/' + this.props.match.params.booking_id + '/edit')
            .then(function(response) {
                self.props.dispatch(setBookingsDb([response?.data.booking], self.props.data.bookings_db))
                self.props.dispatch(setVehicleDb([response?.data.booking.vehicle], self.props.data.vehicle_db))
                var current_time = moment().add(30 - (moment().get('minute') % 30), 'minutes').format("h:mm A")
    
                var current_form = {
                    'damage': 0,
                    'fuel': response?.data.view.fuel,
                    'date': moment(response?.data.booking.Start_Date).format("YYYY-MM-DD"),
                    'time': receiveTime(current_time),
                    'name': self.props.userSession.user.full_name,
                    'damage_notes': response?.data.view.damage_notes
                }
                
                self.setState({
                    current_form: current_form,
                    form_details: response?.data.view,
                    vehicle_id: response?.data.booking.V_ID,
                    current_time: current_time,
                    previous_odometer: response?.data.view.km,
                    timings: generateTimings(response?.data.booking.vmh.Hours_Week_Start, response?.data.booking.vmh.Hours_Week_End),
                    current_booking: response?.data.booking
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";
    
                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });
    
                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        } else {
            axios.get('/ajax/return/' + this.props.match.params.booking_id + '/edit')
            .then(function(response) {
                self.props.dispatch(setBookingsDb([response?.data.booking], self.props.data.bookings_db))
                self.props.dispatch(setVehicleDb([response?.data.booking.vehicle], self.props.data.vehicle_db))
                var current_time = moment().add(30 - (moment().get('minute') % 30), 'minutes').format("h:mm A")

                var current_form = {
                    'damage': 0,
                    'fuel': response?.data.view.fuel,
                    'date': moment(response?.data.booking.End_Date).format("YYYY-MM-DD"),
                    'time': receiveTime(current_time),
                    'name': self.props.userSession.user.full_name,
                    'damage_notes': response?.data.view.damage_notes
                }
                
                self.setState({
                    current_form: current_form,
                    form_details: response?.data.view,
                    vehicle_id: response?.data.booking.V_ID,
                    current_time: current_time,
                    previous_odometer: response?.data.view.km,
                    timings: generateTimings(response?.data.booking.vmh.Hours_Week_Start, response?.data.booking.vmh.Hours_Week_End),
                    current_booking: response?.data.booking
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        }
        
    }

    updateForm(event) {
        var value = event.target.value
        var name = event.target.name

        var new_form = this.state.current_form
        var error_class = this.state.error_class
        if (name === "date") {
            value = moment(value, "MMM DD, YYYY").format("YYYY-MM-DD")
        }
        else if(name == "odometer")
        {
            error_class[name] = false;
        } else if (name == 'damage_notes') {
            if (value !== '') {
                this.updateDamage("1");
            } else {
                this.updateDamage("0");
            }
        }

        new_form[name] = value

        this.setState({
            current_form: new_form,
            error_class: error_class
        })
    }

    updateSelect(optionSelected) {
        var value = optionSelected.value
        var name = optionSelected.name

        if (name === "time") {
            value = receiveTime(value)
        } else if (name === "damage") {
            this.setState({
                damage: ! parseInt(value)
            })
        }

        var current_form = this.state.current_form
        current_form[name] = value
        
        this.setState({
            current_form: current_form
        })
    }

    updateDamage(option) {
        var current_form = this.state.current_form
        current_form['damage'] = option

        this.setState({
            damage: parseInt(option),
            current_form: current_form
        })
    }

    updateCheckbox(e, name) {
        var confirms = this.state.confirms
        var error_class = this.state.error_class

        confirms[name] = ! this.state.confirms[name]
        error_class[name] = false

        if(name == "vehicle_confirm" && (this.state.current_form["odometer"] == undefined || this.state.current_form["odometer"] == ""))
        {
            error_class["odometer"] = true;
            confirms["vehicle_confirm"] = false;
            showStatusMsg("You need to enter the current mileage before you can confirm the vehicle details.")
        }

        this.setState({
            confirms: confirms,
            error_class: error_class,
        })
    }

    updateSlider(e) {
        var current_form = this.state.current_form;
        current_form['fuel'] = e;

        this.setState({
            current_form: current_form
        })
    }

    releaseVehicle(callReleaseVehicleGraphQL) {
        var self = this;

        if((!this.state.confirms.vehicle_confirm) || (!this.state.confirms.booking_confirm) || !(this.state.current_form.odometer))
        {
            var error_message = "";
            var booking_confirm, vehicle_confirm, odometer = false;
            if(!this.state.confirms.booking_confirm)
            {
                error_message = "You need to confirm the booking details to release the vehicle.";
                booking_confirm = true;
            } 
            
            if(this.state.current_form.odometer == "" || this.state.current_form.odometer == undefined)
            {
                error_message = (error_message == "" ? error_message : (error_message + "<br />")) + "You need to enter the current mileage to release the vehicle.";
                odometer = true;
            } 
            
            if((!this.state.confirms.vehicle_confirm))
            {
                error_message = (error_message == "" ? error_message : (error_message + "<br />")) + "You need to confirm the vehicle details to release the vehicle.";
                vehicle_confirm = true;
            }

            showStatusMsg(error_message);
            self.setState({
                error_class: {
                    booking_confirm: booking_confirm,
                    vehicle_confirm: vehicle_confirm,
                    odometer: odometer,
                }
            })
            return false;
        }

        axios.post('/ajax/release/' + this.props.match.params.booking_id + "/update", this.state.current_form)
        .then(function(response) {
            // [not in use due to queue data sync implementation]
            // callReleaseVehicleGraphQL(self.state.current_form);
            showStatusMsg('Vehicle released successfully.', 'success');
            self.props.dispatch(closePullout())
            self.props.history.goBack();
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                console.error(error);
                showStatusMsg("Requested information not found");
            }
        })
    }

    returnVehicle(callReturnVehicleGraphQL) {
        var self = this;

        if((!this.state.confirms.vehicle_confirm) || (!this.state.confirms.booking_confirm) || !(this.state.current_form.odometer))
        {
            var error_message = "";
            var booking_confirm, vehicle_confirm, odometer = false;
            
            if(!this.state.confirms.booking_confirm)
            {
                error_message = "You need to confirm the booking details to return the vehicle.";
                booking_confirm = true;
            }

            if(this.state.current_form.odometer == "" || this.state.current_form.odometer == undefined)
            {
                error_message = (error_message == "" ? error_message : (error_message + "<br />")) + "You need to enter the current mileage to return the vehicle.";
                odometer = true;
            } 
            
            if((!this.state.confirms.vehicle_confirm))
            {
                error_message = (error_message == "" ? error_message : (error_message + "<br />")) + "You need to confirm the vehicle details to return the vehicle.";
                vehicle_confirm = true;
            }

            showStatusMsg(error_message);
            self.setState({
                error_class: {
                    booking_confirm: booking_confirm,
                    vehicle_confirm: vehicle_confirm,
                    odometer: odometer,
                }
            })

            return false;
        }

        axios.post('/ajax/return/' + this.props.match.params.booking_id + "/update", this.state.current_form)
        .then(function(response) {
            // var data = {}

            // if (self.props.match.url.split("/")[1] === "bookings") {
            //     data = {
            //         search_term: $("#searchbar").val(),
            //             vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
            //             sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'),
            //             start_date: self.props.stakeholder.current_date.clone().subtract(3, 'weeks'),
            //             end_date: self.props.stakeholder.current_date.clone().add(3, 'weeks')
            //         }

            //     if (self.props.stakeholder.booking_next_page !== null && self.props.stakeholder.booking_next_page > 0) {
            //         data['grab_all_pages'] = self.props.stakeholder.booking_next_page;
            //     }
            // }

            // [not in use due to queue data sync implementation]
            // callReturnVehicleGraphQL(self.state.current_form);
            showStatusMsg('Vehicle returned successfully.', 'success');
            self.props.dispatch(closePullout())
            self.props.history.goBack();
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                console.error(error);
                showStatusMsg("Requested information not found");
            }
        })
    }

    render(props) {
        return (
            <div className = "reveal return-release" id = "releasecheckin-overlay" style={{display: "block"}}>
            {
               this.state.current_booking ?
                    <div className = "releasereturn">
                        <div className = "bkg-white">
                            <div className = "bkg-white border-bottom p-16">
                                <span className = "card-header-title medium"><Trans>{this.props.release ? 'Release' : 'Check-in'} Vehicle</Trans></span>
                                <button style={{marginTop: "10px", color: "lightgray"}} className="close-button" data-close aria-label='Close modal' type='button' onClick={this.props.history.goBack}>
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                                <div className = "clearfix"></div>
                            </div>

                            <div className="scrollable">
                                <div className = "card-section p-16" style={this.state.confirms.booking_confirm ? {opacity: 0.5} : {opacity: 1}}>
                                    <div className="medium">
                                        <Trans>Booking Details</Trans>
                                    </div>
                                    <div className ="row">
                                        <div className="inner-row">
                                            <div className="row-item">
                                                <div className="centered">
                                                    {VehicleDefault("fill-primary")}
                                                </div>
                                                <div className="stacked-item">
                                                    <div className = "body truncate">{this.state.current_booking.vehicle.Year} {this.state.current_booking.vehicle.Make} {this.state.current_booking.vehicle.Model} {this.state.current_booking.vehicle.Trim}</div>
                                                    <div className = "black-lighter">{this.state.current_booking.vehicle.VIN}</div>
                                                </div>
                                            </div>
                                            <div className="row-item">
                                                <div className="centered">
                                                    {TimeDefault("fill-primary")}
                                                </div>
                                                <div className="stacked-item">
                                                    <div className = "body">{moment(this.state.current_booking.Start_Date).format("ddd MMM DD")}</div>
                                                    <div className = "black-lighter">{moment(this.state.current_booking.Release_Time, "HH:mm:ss").format("h:mmA")}</div>
                                                </div>
                                                <div className="centered" style={{margin: "auto 10px"}}>
                                                    <i style={{color: "lightgray"}} className="fas fa-arrow-right overlay_section_details_date_arrow"></i>
                                                </div>
                                                <div className="stacked-item">
                                                    <div className = "body">{moment(this.state.current_booking.End_Date).format("ddd MMM DD")}</div>
                                                    <div className = "black-lighter">{moment(this.state.current_booking.Return_Time, "HH:mm:ss").format("h:mmA")}</div>
                                                </div>
                                            </div>
                                            <div className="row-item">
                                                <div className="centered">
                                                    {UserDefault("fill-primary")}
                                                </div>
                                                <div className={"stacked-item" + (company_title(this.state.current_booking.profile) == "" ? " centered" : "")}>
                                                    <div className = "body">{this.state.current_booking.profile.First_Name} {this.state.current_booking.profile.Last_Name ? this.state.current_booking.profile.Last_Name : null}</div>
                                                    <div className = "black-lighter truncate" style={{maxWidth: "120px"}}>{company_title(this.state.current_booking.profile)}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="confirm" onClick={(e) => {
                                            this.updateCheckbox(e, "booking_confirm");
                                            setTimeout(()=> {
                                                this.odometerRef.current.focus();
                                            }, 500)
                                            }}>
                                            <label className="centered" style={{width: 100}}>
                                                <div>
                                                {
                                                        this.state.confirms.booking_confirm ?
                                                            ActionApproveUser("#42B53A", "Confirm")
                                                        :
                                                            this.state.error_class.booking_confirm ?
                                                                ActionApproveUser('#c60f13', "Confirm")
                                                            :
                                                                ActionApproveUser('#265BFF', "Confirm")
                                                    }
                                                </div>
                                                <div>
                                                    {this.state.confirms.booking_confirm ? 
                                                    <a style={{color: '#42B53A'}}><Trans>Confirmed</Trans></a>
                                                    : <a><Trans>Confirm</Trans></a>
                                                    }
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className = "card-section p-16" style={(this.state.confirms.booking_confirm && !this.state.confirms.vehicle_confirm) ? {opacity: 1} : {opacity: 0.5}}>
                                    <div className="medium">
                                        <Trans>Vehicle Details</Trans>
                                    </div>
                                    <div className ="row">
                                        <div className="inner-row">
                                            <div className="row-item">
                                                <label>
                                                    <span className="label-type"><Trans>Fuel</Trans></span>
                                                    <div style={{display: "flex", marginTop: '15px'}} className="fuel-slider">
                                                        <span style={{marginRight: "8px", color: 'lightgray'}}>E</span>
                                                        <Slider 
                                                            style={{margin: "auto"}}
                                                            disabled={!(this.state.confirms.booking_confirm && !this.state.confirms.vehicle_confirm)}
                                                            dots 
                                                            step={1} 
                                                            min={0} 
                                                            max={8} 
                                                            marks={{2: {style: {top:"-5px"}, label: <span style={{fontSize:"14px", color: "lightgray"}}>¼</span>}, 4: {style: {top:"-5px"}, label: <span style={{fontSize:"14px", color: "lightgray"}}>½</span>}, 6: {style: {top:"-5px"}, label: <span style={{fontSize:"14px", color: "lightgray"}}>¾</span>}, [parseInt(this.state.current_booking.Fuel_Pre)]: {style: {top:"-50px"}, label: <span style={{fontSize:"14px", color: "gray"}}>Previous<br /><i className="fas fa-caret-down" style={{marginTop: "-5px", marginLeft: "-3px", position: "absolute"}}></i></span>}}}
                                                            defaultValue={this.state.current_booking?.Fuel_Pre ? parseInt(this.state.current_booking.Fuel_Pre) : 8}
                                                            onChange={(e) => this.updateSlider(e)}
                                                        />
                                                        <span style={{marginLeft: "8px", color: 'lightgray'}}>F</span>
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="row-item">
                                                <label>
                                                    <span className="label-type"><Trans>Mileage</Trans></span>
                                                    <div className="flex-row" style={{marginTop: '15px'}}>
                                                        <div className = "input-group label-right form-95" style={{height: "27px", width: "120px"}}>
                                                            <input className="input-group-field margin-none" type = "number" name = "odometer" style={{height: "25px"}} disabled defaultValue = {this.state.previous_odometer}/>
                                                            <span className = "input-group-label" >KM</span>
                                                        </div>
                                                        <div className="centered" style={{margin: "auto 10px"}}>
                                                            <i style={{color: "lightgray"}} className="fas fa-arrow-right overlay_section_details_date_arrow"></i>
                                                        </div>
                                                        <div className={"input-group label-right form-95 " + (this.state.error_class.odometer ? "error" : "")} style={{height: "27px", width: "120px"}}>
                                                            <input className="input-group-field margin-none" type = "number" disabled={!(this.state.confirms.booking_confirm && !this.state.confirms.vehicle_confirm)} name = "odometer" style={{height: "25px"}} onChange={this.updateForm} ref={this.odometerRef}/>
                                                            <span className = "input-group-label darker" >KM</span>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                        <div className={"confirm" + (this.state.current_form.odometer ? "" : " disabled")}  onClick={(e) => {if (this.state.confirms.booking_confirm) {this.updateCheckbox(e, "vehicle_confirm")}}} disabled={!(this.state.confirms.booking_confirm && !this.state.confirms.vehicle_confirm)}>
                                            <label className="centered" style={{width: 100}}>
                                                <div>
                                                {
                                                        this.state.confirms.vehicle_confirm ?
                                                            ActionApproveUser("#42B53A", "Confirm")
                                                        :
                                                            this.state.error_class.vehicle_confirm ?
                                                                ActionApproveUser('#c60f13', "Confirm")
                                                            :
                                                                ActionApproveUser('#265BFF', "Confirm")
                                                    }
                                                </div>
                                                <div>
                                                    {this.state.confirms.vehicle_confirm ? 
                                                    <a style={{color: '#42B53A'}}><Trans>Confirmed</Trans></a>
                                                    : <a><Trans>Confirm</Trans></a>
                                                    }
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className = "card-section p-16" style={(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm && !this.state.confirms.damage_confirm) ? {opacity: 1} : {opacity: 0.5}}>
                                    <div className="medium">
                                        <Trans>Damage</Trans>
                                    </div>  
                                    <div className="row">
                                        <textarea
                                            placeholder="No damage" 
                                            name="damage_notes"
                                            value={this.state.current_form.damage_notes}
                                            style={{minHeight: 80, marginRight: 30}} 
                                            className={parseInt(this.state.damage) ? "" : "hide-mobile" } 
                                            readOnly={!(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm && (!this.state.confirms.damage_confirm))} 
                                            onChange={this.updateForm}>
                                        </textarea>
                                        <div 
                                            className={"confirm" + (this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm ? "" : " disabled")} 
                                            onClick={(e) => {this.updateCheckbox(e, "damage_confirm")}}
                                            disabled={!(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm)}>
                                            <label className="centered" style={{width: 100}}>
                                                <div>
                                                {
                                                        this.state.confirms.damage_confirm ?
                                                            ActionApproveUser("#42B53A", "Confirm")
                                                        :
                                                            this.state.error_class.damage_confirm ?
                                                                ActionApproveUser('#c60f13', "Confirm")
                                                            :
                                                                ActionApproveUser('#265BFF', "Confirm")
                                                    }
                                                </div>
                                                <div>
                                                    {this.state.confirms.damage_confirm ? 
                                                    <a style={{color: '#42B53A'}}><Trans>Confirmed</Trans></a>
                                                    : <a><Trans>Confirm</Trans></a>
                                                    }
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                    {/* <div className ="row">
                                        <div className="confirm">
                                            <span className="mr-8" style={{cursor: "pointer"}}  onClick={(e) => this.updateCheckbox(e, "damage_confirm")}>
                                                {ActionApproveUser()}
                                            </span>
                                        </div>
                                    </div> */}
                                </div>
                                <div className = "card-section p-16" style={(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm && this.state.confirms.damage_confirm) ? {opacity: 1} : {opacity: 0.5}}>
                                    <div className="medium">
                                        <Trans>{this.props.release ? 'Release' : 'Check In' } Details</Trans>
                                    </div>
                                    <div className="row" style={{flexWrap: 'wrap'}}>
                                        <div style={{marginRight: '10px'}}>
                                            <label>
                                                <span className="label-type"><Trans>{this.props.release ? 'Released' : 'Checked In'} By</Trans></span>
                                                <input 
                                                    type = "text" 
                                                    placeholder = "" 
                                                    name="name" 
                                                    defaultValue={this.props.userSession.user.full_name} 
                                                    className="form-95 detailer" 
                                                    onChange={this.updateForm} 
                                                    style={{
                                                        padding: "0 5px",
                                                        width: "250px"
                                                    }}
                                                    disabled={!(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm && this.state.confirms.damage_confirm)}
                                                />
                                            </label>        
                                        </div>
                                        <div style={{display: 'flex', flex: 1}}>
                                            <div className = "date-time" style={{marginTop: "5px", width: '100%'}}>
                                                <div className = "medium label-type" style = {{marginBottom:"3px"}}>
                                                    <Trans>{this.props.release ? 'Released' : 'Checked In'} At</Trans>
                                                </div>
                                                <div style={{flex: 1, display: 'flex', flexDirection: 'row'}}>
                                                    <div style={{width: '150px'}}>
                                                        {this.props.release ? 
                                                            <DatePicker id="released_on_datepicker" classname="datepicker date-input-field" name="date" 
                                                            value={moment(this.state.current_form.date, "YYYY-MM-DD").format("MMM DD, YYYY")} disabled={!(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm && this.state.confirms.damage_confirm)} 
                                                                mindate={this.state.form_details.min_release_date} maxdate={this.state.form_details.max_release_date} updateValue={this.updateForm} 
                                                                style={{
                                                                    padding: "0 5px",
                                                                    height: "30px",
                                                                    width: "150px",
                                                                    maxWidth: "150px"
                                                                }}
                                                            /> : 
                                                            <DatePicker id="returned_on_datepicker" classname="datepicker date-input-field" name="date" 
                                                            value={moment(this.state.current_form.date, "YYYY-MM-DD").format("MMM DD, YYYY")} disabled={!(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm && this.state.confirms.damage_confirm)} 
                                                            mindate={this.state.form_details.min_return_date} maxdate={this.state.form_details.max_return_date} updateValue={this.updateForm} 
                                                                style={{
                                                                    padding: "0 5px",
                                                                    height: "30px",
                                                                    width: "150px",
                                                                    maxWidth: "150px"
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                    <div style={{width: '250px', marginLeft: 10}}>
                                                        <span className="select-up">
                                                            <Select 
                                                                options={
                                                                    this.state.timings.map((time) => {
                                                                        return(
                                                                            {label: time, value: time, name:"time"}
                                                                        )
                                                                    })
                                                                }
                                                                name="time"
                                                                defaultValue={{label: this.state.current_time, value: this.state.current_time, name:"time"}}
                                                                onChange={this.updateSelect}
                                                                className="react_select_dropdown"
                                                                classNamePrefix="react_select"
                                                                menuPlacement="top"
                                                                isDisabled={!(this.state.confirms.booking_confirm && this.state.confirms.vehicle_confirm && this.state.confirms.damage_confirm)}
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className = "card-button-section float-right">
                                <a className = "button px-32" aria-label="Close modal" onClick={this.props.history.goBack}><Trans>Cancel</Trans></a>
                                <ReleaseCheckInVehicleButton
                                    calendarBooking={this.state.calendarBooking}
                                    legacyApiReleaseVehicle={this.releaseVehicle}
                                    legacyApiReturnVehicle={this.returnVehicle}
                                    isRelease={this.props.release}
                                    confirms={this.state.confirms}
                                    closeModal={this.props.closeModal}
                                    // releaseVehicleIcon={ReleaseVehicle()}
                                    sourceBookingId={this.props.match.params.booking_id}
                                />
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
               :
                    <LoadingIcon />
            }
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(ReleaseCheckInOverlay)